import {
  Box,
  Menu,
  MenuButton,
  MenuButtonProps,
  MenuItem,
  MenuList,
} from "@chakra-ui/react";
import Image from "components/Image";
import { defaultAvatarPath } from "constants/file";
import { useAppNetwork } from "contexts/OfflineContext";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { resetWidgetsMode } from "redux/forgeViewerSlice";
import { RootState } from "redux/store";
import { routePath } from "routes/path";
import { logout } from "utils/user";

interface Props extends MenuButtonProps {}

function ProfileMenu({ ...rest }: Props) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { isOnline } = useAppNetwork();
  const { currentUser } = useSelector((state: RootState) => state.user);
  const { widgetsMode } = useSelector((state: RootState) => state.forgeViewer);

  const onLogout = async () => {
    widgetsMode && dispatch(resetWidgetsMode());
    await logout();
  };

  const openProfilePage = () => {
    widgetsMode && dispatch(resetWidgetsMode());

    return navigate(routePath.Profile);
  };

  return (
    <Box flexShrink="0" bg="white">
      <Menu autoSelect={false}>
        <MenuButton className="profile-menu" w="3.6rem" h="3.6rem" {...rest}>
          <Image
            cursor="pointer"
            src={currentUser?.avatar}
            fallbackSrc={defaultAvatarPath}
            borderRadius="50%"
            objectFit="cover"
            {...(rest as any)}
          />
        </MenuButton>
        <MenuList ml="1rem" minW="17.6rem" p="0">
          <MenuItem
            isDisabled={!isOnline}
            onClick={openProfilePage}
            p=".5rem 1.5rem"
            lineHeight="2.4rem"
            color="#171717"
            borderBottom="1px solid var(--primary-border-color)"
            _hover={{ bgColor: "#F0F9FF !important" }}
          >
            ユーザー
          </MenuItem>
          <MenuItem
            isDisabled={!isOnline}
            onClick={onLogout}
            color="#171717"
            p=".5rem 1.5rem"
            _hover={{ bgColor: "#F0F9FF !important" }}
          >
            ログアウト
          </MenuItem>
        </MenuList>
      </Menu>
    </Box>
  );
}

export default ProfileMenu;
